import type { PaymentMethodType } from '../../../../../services/commonCheckout/types/PaymentMethod';
import PaymentMethodTypes from '../../../../../services/commonCheckout/utils/PaymentMethodTypes';
import type { FormattedPaymentMethod } from '../types';

export const isFormattedCardPaymentMethod = (
  paymentMethod: FormattedPaymentMethod<PaymentMethodType>,
): paymentMethod is FormattedPaymentMethod<'CARD'> => {
  return paymentMethod.type === PaymentMethodTypes.CARD;
};
